module.exports = __webpack_public_path__ + "img/9.fc95fdaf.png";